<template>
    <div class="navBar">
              

      <img src="../assets/logoTcan.png" alt="Tecnoservice logo">
      <div class="nav" v-if="!isMobile">
        <router-link
            to="/"
            class="nav-link"
            exact-active-class="paginaCorrente">
            Home
        </router-link>
        <router-link
            to="/chisiamo"
            class="nav-link"
            exact-active-class="paginaCorrente">
            Chi Siamo
        </router-link>
        <router-link
            to="/prodotti"
            class="nav-link"
            exact-active-class="paginaCorrente">
            Prodotti
        </router-link>
        <router-link
            to="/contatti"
            class="nav-link"
            exact-active-class="paginaCorrente">
            Contatti
        </router-link>
      </div>
      <div class="nav-mobile" v-else>
        <div class="nav_btn" v-on:click="show=true" v-if="show==false">
          <i class="fa-solid fa-bars fa-2x" @click="toggleShow(), inAnim()"></i>
        </div>
        <div class="slide" v-if="show==true" :class="deleting ? 'deleting' : ''">
          <i class="fa-solid fa-xmark fa-2x" v-on:click="deleting=true, outAnim()"></i>
          <router-link
              to="/"
              class="nav-link"
              exact-active-class="paginaCorrente">
              Home
          </router-link>
          <router-link
              to="/chisiamo"
              class="nav-link"
              exact-active-class="paginaCorrente">
              Chi Siamo
          </router-link>
          <router-link
              to="/prodotti"
              class="nav-link"
              exact-active-class="paginaCorrente">
              Prodotti
          </router-link>
          <router-link
              to="/contatti"
              class="nav-link"
              exact-active-class="paginaCorrente">
              Contatti
          </router-link>
        </div>
      </div>
    </div>
</template>


<script>
    export default {
      name: 'NavBar',
      props: {
        msg: String
      },
      data() {
        return {
          windowWidth: window.innerWidth,
          show: false,
          deleting: false
        };
      },
      computed: {
        isMobile() {
          return this.windowWidth <= 768; // breakpoint classico
        }
      },
      methods: {
        handleResize() {
          this.windowWidth = window.innerWidth;
        },
        toggleShow() {
          this.show = !this.show;
        },
        outAnim: function() {
          this.deleting=true;
          this.clock = setTimeout(() => {
              this.show=false;
              this.deleting=false;
          }, 1000);
        } 
      },
      mounted() {
        window.addEventListener('resize', this.handleResize);
      },
      beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
      }
    }
</script>

<style lang="scss" scoped>

  .navBar {
    display: flex;
    position: relative;
    height: 10vh;
    padding-left: 10vw;
    padding-right: 10vw;
    margin-top: 5vh;
    align-items: center;
    justify-content: space-between;
    z-index: 2;

    // Rende il logo verde scuro in quanto come PNG era verde chiaro
    // Il "Border Radius" serve perchè lo sfondo nero sia solo sotto il cerchio verde del logo
    img {
      height: 70%;
      width: auto;
      background-color: black;
      border-radius: 50%;
    }
    .nav {
      width: 100vw;
    }
  }

  // Stile dei link della navBar
  .nav-link {
    display: inline-block;
    margin-right: 2vw;
    padding-right: 2vw;
    border-right: 1px solid white;
    text-decoration: none;
    color: black;
    font-size: 1rem;
  }

  //Fa in modo che la pagina attuale si colori di arancione
  .paginaCorrente {
    text-transform: uppercase;
    font-size: 1.1rem;
    color: $tcan_orange;
    font-weight: 900;
  }
  .deleting {
    animation: slide_out 2s;
  }
  .slide {
    animation: slide_in 1s;
  }


  @keyframes slide_in {
    0% {
        position: relative;
        left: 150%;
    }
    100% {
        position: relative;
        left: 0;
    } 
}
@keyframes slide_out {
    0% {
        position: relative;
        left: 0;
    } 
    100% {
        position: relative;
        left: 150%;
    }
}
</style>
